import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import css from './css.css';
import { Container } from "~/native-ui";
export default class CenterWrapper extends Component {
    static propTypes = {
        full: PropTypes.bool.isRequired,
        overflow: PropTypes.bool.isRequired,
        innerClass: PropTypes.string,
        shadow: PropTypes.number,
    };

    static defaultProps = {
        full: false,
        overflow: false,
    };

    containerClasses = () => classNames(
        this.props.className,
        css.container, {
            [css.containerFull]: this.props.full
        }
    );

    innerClasses = () => classNames(css.inner,
        this.props.innerClass, {
            [css.innerOverflow]: this.props.overflow
        }
    );

    render() {
        const { full, ...props } = this.props
        return (
            <Container { ...props } />
        );
    }
}